import type { ArgoCDApplicationAnnotation } from "@octopusdeploy/octopus-server-client";
import { ArgoCDAnnotationKeys } from "@octopusdeploy/octopus-server-client";
export function createAnnotation(projectSlug: string, environmentSlug: string, tenantSlug: string | undefined): string {
    const annotations: Partial<Record<ArgoCDApplicationAnnotation, string | undefined>> = {
        [ArgoCDAnnotationKeys.Project]: projectSlug,
        [ArgoCDAnnotationKeys.Environment]: environmentSlug,
        [ArgoCDAnnotationKeys.Tenant]: tenantSlug,
    };
    let annotation = `metadata:
  annotations:`;
    for (const [key, value] of Object.entries(annotations)) {
        if (value) {
            annotation += `\n    ${key}: "${value}"`;
        }
    }
    return annotation;
}
